module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ls3cj"))).then(() => parcelRequire('d0iPb'));